import React from 'react';
import AdminManageSettingsDataUpload from './admin-manage-settings-data-upload';
import AdminManageSettingsComparisonTable from './admin-manage-settings-comparison-table';
import * as adminService from '../../services/admin-service';

const spocsConfig = {
  title: 'Manage SPOCs',
  description: 'Upload SPOC assignments. Account, SPOC name, and email are required.',
  uploadTitle: 'Upload SPOCs File',
  entityName: 'SPOCs',
  fileInputId: 'spocs',
  uploadService: adminService.uploadSpocsFile,
  bulkUpdateService: adminService.bulkUpdateSpocs,
  downloadFileService: adminService.downloadSpocsFile,
  getFileInfoService: adminService.getSpocsFileInfo,
  idField: 'record_key',
  columns: [
    { field: 'account', label: 'Account' },
    { field: 'spoc_name', label: 'SPOC Name' },
    { field: 'spoc_email', label: 'SPOC Email' },
    { field: 'team', label: 'Team' },
    { field: 'business', label: 'Business' },
    { field: 'region', label: 'Region' },
    { field: 'country', label: 'Country' },
    { field: 'state_province', label: 'State/Province' },
    { field: 'city', label: 'City' },
    { field: 'geo', label: 'Geo' },
    { field: 'services', label: 'Services' },
  ],
  viewAllConfig: {
    entityName: 'SPOCs',
    fetchAllService: adminService.fetchSpocs,
    idField: 'id',
    searchFields: ['account', 'spoc_name', 'spoc_email'],
    columns: [
      { key: 'account', label: 'ACCOUNT', width: '180px' },
      { key: 'spoc_name', label: 'SPOC NAME', width: '200px' },
      { key: 'spoc_email', label: 'SPOC EMAIL', width: '240px' },
      { key: 'team', label: 'TEAM', width: '180px' },
      { key: 'business', label: 'BUSINESS', width: '180px' },
      { key: 'region', label: 'REGION', width: '160px' },
      { key: 'country', label: 'COUNTRY', width: '160px' },
      { key: 'state_province', label: 'STATE/PROVINCE', width: '180px' },
      { key: 'city', label: 'CITY', width: '160px' },
      { key: 'geo', label: 'GEO', width: '160px' },
      { key: 'services', label: 'SERVICES', width: '240px' },
    ],
  },
};

const AdminManageSpocs = () => (
  <AdminManageSettingsDataUpload
    config={spocsConfig}
    ComparisonTableComponent={AdminManageSettingsComparisonTable}
  />
);

export default AdminManageSpocs;
